const data = [
  { id: 1, name: "Credor" },
  { id: 2, name: "Ministério Público" },
  { id: 3, name: "Administração Judicial" },
  { id: 4, name: "Recuperanda" },
  { id: 5, name: "Terceiro interessado" },
  { id: 6, name: "Perito" },
  { id: 7, name: "Outro" },
];

export default [...data];
